import {createContext} from "react";

// This context stores the name of the file currently being viewed.
const ActiveFileContext = createContext();

export default ActiveFileContext;
